<template>
	<div class="card mb-0 shadow">
		<div class="card-body">
			<div class="tab-content">
				<div class="animate__animated animate__fadeIn">
					<div class="row">
						<div class="col-12">
							<h4 class="font-weight-bold">Histórico de Estratégia / Intervenção</h4>
						</div>
						<div class="col-12 mb-3">
							<table
								class="table table-bordered bg-white table-sm"
								v-for="historico in acompanhamento.estrategias"
								:key="historico.id"
							>
								<tr>
									<td>
										Técnico: <b>{{ historico.user_id }}</b>
									</td>
									<td>Data:{{ historico.data }}</td>
								</tr>
								<tr>
									<td colspan="2" v-html="historico.descricao"></td>
								</tr>
							</table>
							<h4 class="text-secondary" v-if="acompanhamento.estrategias.length <= 0">
								<i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
								Nenhum histórico registrado.
							</h4>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["acompanhamento"],
};
</script>
